module.exports = __webpack_public_path__ + "img/MES7Indice5_sommaire.c56212eb.png";